import "./FounderLR.scss";
import { baseUrl } from "../../../utils/apiData";

const FounderLR = ({ data }) => {
  return (
    <section className="founder_lr p_t p_b">
      <div className="content_wrap">
     
        <div className="bi_grid_sec">
          <div className="img_wrap">
            <img
              src={`${baseUrl}/${data?.founder_image}`}
              alt="Founder Profile"
            />
          </div>

          <div className="para_side">
          <h1>{data?.founder_heading}</h1>
            <p
              className="dark box"
              dangerouslySetInnerHTML={{
                __html: data?.founder_description?.replace(/\n/g, "<br />"),
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderLR;
